<div class="login-info">
  <span *ngIf="profilePhoto"><a (click)="toggleShortcut()">
      <img [src]="profilePhoto" alt="me" class="online" (change)="countChange($event)">
      <span class="primary-font">{{userProfileDetails.userName}}</span>
      <!-- <i class="fa fa-angle-down"></i> -->
    </a>
    <i class="fa fa-tumblr test-icon" *ngIf="environment=='TEST'" title="{{'test_portal' | i18n}}"></i>
  </span>
</div>